import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {Cell} from 'notebook/tables/constants/CellConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import Excess from 'notebook/tables/excess';
import TableUtil from 'notebook/tables/TableUtil';

/**
 * A utility method to get a blank row given an index and the columns
 * in this table.  This can be used as the base for the
 * `StructuredTableAdapter.getBlankRow` method and then overriden to
 * provide specific functionality on a case by case basis.
 *
 * Agent keep in sync: get_blank_row in benchling/notebook/structured_tables/get_blank_row.py
 */
export default function getBlankRow(
  rowIndex: number,
  structuredTableColumns: Array<StructuredTableColumn>,
  stageRunName: string | null
): Array<Cell> {
  return structuredTableColumns.map((structuredTableColumn, columnIndex) => {
    // if we're adding a row to a single input, ensure that we create an empty cell
    if (structuredTableColumn.isSingleInput && rowIndex > 0) {
      return TableUtil.makeEmptyCell();
    }
    if (stageRunName != null && structuredTableColumn.columnType === TableColumnType.STAGE_RUN) {
      return {text: stageRunName};
    } else {
      const value = structuredTableColumn.defaultValue;
      // Shift the formula (if applicable) to act on the current row.
      const relativeText = Excess.tokenizer.toRelativeFormula(value.text, {row: 0, column: columnIndex});
      const absoluteText = Excess.tokenizer.toAbsoluteFormula(relativeText, {
        row: rowIndex,
        column: columnIndex,
      });
      return {
        ...value,
        text: absoluteText,
      };
    }
  });
}
